import React, { Component } from 'react';

class SmartLink extends Component {
  state = {
    isLoading: false,
  };

  handleClick = (e) => {
    e.preventDefault();
    this.setState({
      isLoading: true,
    });

    this.props.onClick()
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  }

  render() {
    if (this.state.isLoading) {
      return (<span className="icon"><i className="fa fa-spinner fa-spin"></i></span>);
    }

    return (<a href="#" onClick={this.handleClick}>Make Primary</a>);
  }
}

export default SmartLink;
